export default __webpack_public_path__ + "static/cover_1024-b2f66f8e4ba3638bf2e3a06930b5afe6.jpg";